import { unwrapResult } from "@reduxjs/toolkit";

// OG unwrapResult just returns an Object with the attributes of an Error
// console.logging that object does not do the same thing as console.logging an Error
// Specifically, it doesn't sourcemap line numbers. This fixes the issue
// See https://github.com/reduxjs/redux-toolkit/blob/master/packages/toolkit/src/createAsyncThunk.ts#L666-L676 for more details
export const betterUnwrapResult = async (data) => {
  try {
    return await unwrapResult(data);
  } catch (e) {
    if (e.name && e.message) {
      const err = new Error();
      err.name = e.name;
      err.message = e.message;
      err.stack = e.stack;
      throw err;
    }
    return null;
  }
};
